module.exports = __webpack_public_path__ + "img/Technology_img1.2c6e8ead.jpg";